export const transformPagesToList = (pages: unknown = []) => {
  if (!Array.isArray(pages)) return [];
  return pages.flatMap((page) => page.data);
};

interface DataPageProps {
  headers: unknown[];
  rows: unknown[];
}

interface RowPage {
  data: DataPageProps;
}

export const extractRow = (pages: RowPage[]) => {
  if (!pages || pages.length === 0) return [];
  return pages.flatMap((page) => page.data.rows);
};
